import { Component, OnInit, Input } from '@angular/core';
import { NavigationStart, Router } from '@angular/router'
import { Observable, of, BehaviorSubject } from 'rxjs';
import { RealTimeService } from './../../services/real-time.service';
import { map, filter } from 'rxjs/operators';
import moment from 'moment-timezone';
import { Subscription, timer } from 'rxjs';
import { LoginService } from 'src/app/services/login/login.service';


@Component({
  selector: 'app-rt-graphics',
  templateUrl: './rt-graphics.component.html',
  styleUrls: ['./rt-graphics.component.scss']
})
export class RtGraphicsComponent implements OnInit {

  constructor(private rtService: RealTimeService,
    private loginService: LoginService,
    private router: Router) {

  }

  @Input() layout: any;
  @Input() config: any;
  @Input() data: any;
  @Input() dataTraces: Array<any>;

  trace$: Observable<any> = of(null);
  timerSubscription: Subscription;
  realTimeSubscription: Subscription;
  requestDataSubscription: Subscription
  navigationSubscription: Subscription
  _x: number[] = [];
  _y: number[] = [];
  _iter = 0;
  data$: Observable<{ topic: string, data: { x: number[], y: number[] } } | null> = of(null);
  data2$: Observable<any> = of(null);


  extendConfig(data: any) {
    this.layout["annotations"] = [
      {
        x: data.x[data.x.length - 1],
        y: data.y[data.y.length - 1],
        xref: 'x',
        yref: 'y',
        text: "<b>" + data.y[data.y.length - 1] + "<b>",
        showarrow: true,
        arrowhead: 7,
      }

    ]
  }

  ngOnInit() {
    this.getData()
  }

  getData() {
    this.requestDataFromTopics();

    this.rtService.subscribeToMqttRT().subscribe(res => {
      this.trace$ = this.connect('scatter', 'lines+markers', this.data.mqtt.subscribeTopic, res.data.realTimeSubscription.payload, 'rgb(0, 30, 255)')
        .pipe(
          map((data) => {
            // this.extendConfig(data.data)
            const layout = this.layout
            const config = this.config
            this.parseTraceDates(data)
            return { ...data.data, layout, config };
          }
          )
        )
    })
  }

  requestDataFromTopics() {
    this.timerSubscription = timer(0, 45000).pipe(
      map(() => {
        this.rtService.subscriptionRequest(this.data.mqtt.publishTopic, "true").subscribe(res => {
        })
      })
    ).subscribe();
  }

  parseTraceDates(trace: any): string[] {
    let dateAux: string[] = [];
    let traceAux;
    const timezone = this.loginService.currentUserValue.timeZone;
    for (let elem of trace.data.x) {
      dateAux.push(moment.unix(elem / Math.pow(10, 3)).tz(timezone).format('YYYY-MM-DD HH:mm:ss'))
    }
    traceAux = Object.assign(trace, {})
    traceAux.data["x"] = dateAux;
    return dateAux;
  }

  connect(type: string, mode: string, topic: string, payload: any, color: string = 'rgb(55, 128, 191)') {
    if (topic == payload.topic) {
      this.data$ = new BehaviorSubject(null)
        .pipe(
          map(() => {
            this._x.push(payload.fecha);
            this._y.push(
              parseFloat(payload.valor)
            );
            if (this._y.length > 50) {
              this._x = this._x.slice(1, -1);
              this._y = this._y.slice(1, -1);
            }
            return {
              topic: payload.topic,
              data: {
                x: this._x,
                y: this._y,
                line: {
                  color: color,
                  width: 1
                },
                mode: mode,
                type: type,

              }
            }
          })
        );
    }
    return this.data$;

  }

  ngOnDestroy() {
    this.rtService.subscriptionRequest(this.data.mqtt.publishTopic, "false").subscribe(res => { })
    if (this.realTimeSubscription) this.realTimeSubscription.unsubscribe();
    if (this.timerSubscription) this.timerSubscription.unsubscribe();
    if (this.requestDataSubscription) this.requestDataSubscription.unsubscribe();
  }

}
